import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppThunk } from '../../app/store';
import { getTranslations, Translations } from '../../api/translationsAPI';

interface TranslationState {
  value: Translations;
  isLoading: boolean;
  error: string | null;
}

const initialState: TranslationState = {
  value: {},
  isLoading: false,
  error: null,
};

function startLoading(state: TranslationState) {
  state.isLoading = true;
}

function loadingFailed(state: TranslationState, action: PayloadAction<string>) {
  state.isLoading = false;
  state.error = action.payload;
}

export const translationSlice = createSlice({
  name: 'translation',
  initialState,
  reducers: {
    getTranslationsStart: startLoading,
    getTranslationsSuccess(state, { payload }: PayloadAction<Translations>) {
      state.value = payload;
      state.isLoading = false;
      state.error = null;
    },
    getTranslationsFailure: loadingFailed,
  },
});

export const { getTranslationsStart, getTranslationsSuccess, getTranslationsFailure } = translationSlice.actions;

export default translationSlice.reducer;

export const fetchTranslations = (query: string): AppThunk => async (dispatch) => {
  try {
    dispatch(getTranslationsStart());
    const translations = await getTranslations(query);
    dispatch(getTranslationsSuccess(translations));
  } catch (err) {
    if (err instanceof Error) {
      dispatch(getTranslationsFailure(err.message));
    } else {
      dispatch(getTranslationsFailure("Can't dispatch getTranslations"));
    }
  }
};
